export const convertUtcToLocal = (utcDateString) => {
    const utcDate = new Date(utcDateString); 
    return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000); // Корректируем на часовой пояс
};

export const convertLocalToUtc = (localDate) => {
    const date = localDate instanceof Date ? localDate : new Date(localDate);
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000); // Корректируем на UTC
    return utcDate.toISOString();
};

export const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}